import {Component} from '@angular/core';
import {HttpErrorModalComponent} from './http-error-modal/http-error-modal.component';
import {NoMatchesModalComponent} from './no-matches-modal/no-matches-modal.component';
import {ErrorMessageModalComponent} from './error-message-modal/error-message-modal.component';
import {LeadGenPopupComponent} from './lead-gen-popup/lead-gen-popup.component';

/**
 * Modal Manager Component
 * Orchestrates and renders all modals in the application
 */
@Component({
  selector: 'app-modal-manager',
  standalone: true,
  imports: [
    HttpErrorModalComponent,
    NoMatchesModalComponent,
    ErrorMessageModalComponent,
    LeadGenPopupComponent
  ],
  templateUrl: './modal-manager.component.html',
  styleUrl: './modal-manager.component.scss'
})
export class ModalManagerComponent {
  // This component simply includes the modal components
  // The actual state management is handled by the ModalService
}
